export default __webpack_public_path__ + "static/media/a10.e20baf42.jpg";